
import httpClient from '../httpClient'
import authHeader from './AuthHeader'

class EnvelopeDataService {
  getAll () {
    return httpClient.get('/envelopes', { headers: authHeader() })
  }
  create (data) {
    return httpClient.post('/envelopes', data, { headers: authHeader() })
  }
  update (data) {
    return httpClient.put('/envelopes/' + data.id, data, { headers: authHeader() })
  }
  delete (data) {
    return httpClient.delete('/envelopes/' + data.id, { headers: authHeader() })
  }
}

export default new EnvelopeDataService()
